module.exports = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY_EMA_SALES,
  tenant: 'ema-sales',
  messageLimit: null,
  logo: 'girl-headphones.png',
  messageFlagEnabled: true,
  pageTitle: 'Ema - Sales',
};
